/**
 * County Boundaries Layer
 *
 * Renders MN county polygons from GeoJSON with a semi-transparent dark
 * military-themed style. Each county displays its name in a tooltip.
 */

import React from 'react'
import { GeoJSON, Tooltip } from 'react-leaflet'
import countyData from '../data/mn_counties.json'

const COUNTY_STYLE = {
  color: '#3d5a3e',        // OD green border
  weight: 1.5,
  opacity: 0.8,
  fillColor: '#3d5a3e',
  fillOpacity: 0.08,
  dashArray: '4 3',
}

/**
 * @param {{ visible?: boolean }} props
 */
export function CountyBoundaries({ visible = true }) {
  if (!visible) return null

  return (
    <GeoJSON
      data={countyData}
      style={() => COUNTY_STYLE}
      onEachFeature={(feature, layer) => {
        const name = feature.properties?.NAME || 'Unknown'
        layer.bindTooltip(name)
      }}
    />
  )
}

export default CountyBoundaries
